import {Spinner} from "@cdx/common";
import {Box, css} from "@cdx/ds";
import {animated, useTransition} from "react-spring";
import {ReactNode, Suspense, useEffect, useState} from "react";
import {preventPropagationHandlers} from "./Modals";

const ShowLeftSidebar = ({
  content,
  onClose,
}: {
  content: {element: ReactNode; childKey: string | number} | null;
  onClose: () => void;
}) => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  useEffect(() => {
    if (!node) return;
    const handler = (e: Event) => e.stopPropagation();
    node.addEventListener("wheel", handler);
    return () => {
      node.removeEventListener("wheel", handler);
    };
  }, [node]);
  const renderFn = useTransition(content, {
    key: (item: any) => item?.childKey ?? null,
    from: {x: "-100%", opacity: 0, presence: 0},
    initial: {x: "0%", opacity: 1, presence: 1},
    enter: {x: "0%", opacity: 1, presence: 1},
    leave: {x: "-100%", opacity: 0.75, presence: 0},
    config: {tension: 2500, friction: 90},
  });
  return renderFn(({opacity, x, presence}, shown) =>
    shown ? (
      <Box
        position="fixed"
        inset="0"
        overflow="hidden"
        pointerEvents="none"
        zIndex={6}
        ref={setNode}
      >
        <animated.aside
          style={{opacity, x, maxWidth: "100%"}}
          className={css({
            position: "absolute",
            zIndex: 1,
            display: "flex",
            top: "0",
            bottom: "0",
            left: "0",
            elevation: 200,
            colorTheme: "gray750",
            bg: "foreground",
            pointerEvents: "auto",
          })}
          {...preventPropagationHandlers}
        >
          <Suspense fallback={<Spinner />}>{shown.element}</Suspense>
        </animated.aside>
        <animated.div
          data-cdx-clickable
          className={css({
            position: "absolute",
            top: "0",
            bottom: "0",
            width: "100%",
            height: "100%",
            zIndex: 0,
          })}
          style={{
            background: `#40465ACC`,
            opacity,
            pointerEvents: opacity.to((val) => (val > 0.9 ? "auto" : "none")),
          }}
          {...preventPropagationHandlers}
          onClick={onClose}
        />
      </Box>
    ) : null
  );
};

export default ShowLeftSidebar;
